module.exports = __webpack_public_path__ + "static/img/left_bg.50b51f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/left_bg.png
// module id = Q2uY
// module chunks = 0